import { getProjectUrl } from 'base/blocks_routes';
import {
  GenericErrorDialog,
  getLimitErrorDialog,
  LoadingDialog,
} from 'base/ui/error_dialogs';
import { menuItem } from 'base/ui/menu_model';
import { BlocksService } from 'blocks/blocks_service';
import { ShowUpgradeWallFn } from 'blocks/editor/session/upgrade_dialog';
import { observable } from 'mobx';
import React from 'react';
import { Project } from '../model';

export function createDuplicateDialog(
  project: Project,
  projectToken: string,
  blocksService: BlocksService,
  showUpgradeWall?: ShowUpgradeWallFn,
) {
  const dialogBox = observable.box<React.ReactElement | undefined>();

  function duplicate() {
    if (dialogBox.get()) return;
    const name = project.name || 'Untitled Project';
    dialogBox.set(<LoadingDialog title={`Duplicating ${name}...`} />);
    blocksService
      .projectDuplicate({ projectToken })
      .then((res) => (window.location.href = getProjectUrl(res.token)))
      .catch((e) => {
        const LimitErrorDialog = getLimitErrorDialog(e);
        if (LimitErrorDialog && showUpgradeWall) {
          dialogBox.set(undefined);
          return showUpgradeWall('projects');
        }
        dialogBox.set(
          LimitErrorDialog ? (
            <LimitErrorDialog onClose={() => dialogBox.set(undefined)} />
          ) : (
            <GenericErrorDialog
              title="Error duplicating project"
              error={e}
              dismiss={() => dialogBox.set(undefined)}
            />
          ),
        );
      });
  }

  return {
    menuItem: menuItem({ label: 'Duplicate project', onClick: duplicate }),
    getDialog: () => dialogBox.get(),
  };
}
